import React from "react";
import { withSiteData } from "react-static";
//
import Header from "components/header";
//
export default withSiteData(({ menu }) => <Header {...menu} />);
